// extracted by mini-css-extract-plugin
module.exports = {"logoSpinner":"LogoSpinner_logoSpinner__3izTC","spinner":"LogoSpinner_spinner__3Pu5A","logospin":"LogoSpinner_logospin__1E8Yt"};